import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@getro/rombo';
import { Flex } from 'rebass/styled-components';

const CustomCheckboxRenderer = ({ data, onSelect, selectedAll, isBulkSelection, ...props }) => (
  <Flex justifyContent="center" alignItems="center" height="100%" minWidth="16px" sx={{ ...props.sx }}>
    <Checkbox
      containerProps={{ width: '16px', minWidth: '16px' }}
      sx={{ label: { p: '0px' } }}
      name="job"
      disabled={data.disabled}
      checked={isBulkSelection ? selectedAll : data.selected}
      onChange={(e) => {
        onSelect(data?.original, e.target.checked, isBulkSelection);

        if (!isBulkSelection) {
          props.node.setSelected(e.target.checked);
        }

        if (isBulkSelection) {
          props.api[e.target.checked ? 'selectAll' : 'deselectAll']();
        }
      }}
    />
  </Flex>
);

CustomCheckboxRenderer.propTypes = {
  onSelect: PropTypes.func,
  data: PropTypes.object,
  selectedAll: PropTypes.bool,
  isBulkSelection: PropTypes.bool,
  node: PropTypes.object,
  api: PropTypes.object,
  sx: PropTypes.object,
};

CustomCheckboxRenderer.defaultProps = {
  selectedAll: false,
  isBulkSelection: false,
  onSelect: () => {},
  data: {},
  node: {},
  api: {},
  sx: {},
};

export default CustomCheckboxRenderer;
